import { useState } from 'react';

export const QUEUED_SONGS_STORAGE_KEY = 'mixwire-queued-songs';

const areQueuedSongsStoredAsShown = (): boolean =>
  localStorage.getItem(QUEUED_SONGS_STORAGE_KEY) !== 'hidden';

type QueuedSongsVisibility = {
  readonly areQueuedSongsShown: boolean;
  readonly toggleQueuedSongs: () => void;
};

export const useQueuedSongsVisibility = (): QueuedSongsVisibility => {
  const [areQueuedSongsShown, setAreQueuedSongsShown] = useState(areQueuedSongsStoredAsShown);

  return {
    areQueuedSongsShown,
    toggleQueuedSongs: (): void => {
      localStorage.setItem(QUEUED_SONGS_STORAGE_KEY, areQueuedSongsShown ? 'hidden' : 'shown');
      setAreQueuedSongsShown(!areQueuedSongsShown);
    },
  };
};
